import { WmTabList, WmTabItem } from "@watermarkinsights/ripple-react";
import { TabOption } from "../interfaces/Interface";

interface TabComponentProps {
  selectedTab: string;
  onWmTabSelected: (event: any) => void;
  tabOption: TabOption[];
}

export default function TabComponent(props: TabComponentProps) {
  return (
    <WmTabList
      id="tab-with-controller"
      selectedTab={props.selectedTab}
      onWmTabSelected={props.onWmTabSelected}
    >
      {props.tabOption.map((tab: TabOption, index: number) => (
        <WmTabItem tabId={"item-" + (index + 1)} key={tab.id}>
          {tab.name}
        </WmTabItem>
      ))}
    </WmTabList>
  );
}
